import { ErrorType } from '../../../../../global-types';

/**
 * Maps each address validation error code to its user-facing translation key.
 * Extend this record when new error codes are added.
 */
export const errorMessageKeyMap: Record<ErrorType, string> = {
  [ErrorType.Incomplete]: 'addressConfirmation.incompleteAddressMessage',
  [ErrorType.Invalid]: 'addressConfirmation.invalidAddressMessage',
  [ErrorType.MissingPrimaryNumber]: 'addressConfirmation.missingPrimaryNumberMessage',
  [ErrorType.InvalidPrimaryNumber]: 'addressConfirmation.invalidPrimaryNumberMessage',
  [ErrorType.RequiredSecondaryInformationMissing]: 'addressConfirmation.requiredSecondaryInformationMissingMessage',
  [ErrorType.RequiredSecondaryInformationNotRecognized]:
    'addressConfirmation.requiredSecondaryInformationNotRecognizedMessage',
  [ErrorType.InvalidBoxNumber]: 'addressConfirmation.invalidBoxNumberMessage',
};
